import { render, staticRenderFns } from "./IndexDataExport.vue?vue&type=template&id=16c2df31&scoped=true"
import script from "./IndexDataExport.vue?vue&type=script&lang=js"
export * from "./IndexDataExport.vue?vue&type=script&lang=js"
import style0 from "./IndexDataExport.vue?vue&type=style&index=0&id=16c2df31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c2df31",
  null
  
)

export default component.exports